export const POPOVER_POSITION = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM: 'bottom',
};

export const POPOVER_POSITIONS = Object.values(POPOVER_POSITION);
